<template>
  <div>
    <router-view
      :user_profile="user_profile"
      :form_data_key="
        $route.params.rep_type === 'representative'
          ? 'representative'
          : 'beneficiar'
      "
      :form_data="
        $route.params.rep_type === 'representative'
          ? user_profile.userRepresentatives[$route.params.rep_index]
          : $route.name === 'representatives-form-edit'
          ? user_profile.userBeneficiar
          : null
      "
      :form_data_list="
        $route.params.rep_type === 'representative'
          ? user_representatives
          : [user_profile.userBeneficiar]
      "
    ></router-view>
  </div>
</template>
<script>
import RegFormMixin from "../form_mixin";
export default {
  props: ["user_profile"],
  mixins: [RegFormMixin],
  computed: {
    form_data() {
      return this.$route.params;
    },
    user_representatives() {
      return this.user_profile.userRepresentatives.map(data => {
        delete data.id;
        delete data.user_id;
        return data;
      });
    }
  },
  beforeMount() {
    this.$emit("loading-status", false);
    this.$router.push({ name: "representatives-info-list" });
  }
};
</script>
<style>
.rep_minimize {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 20px;
  color: white;
  font-weight: 200;
  margin-bottom: 10px;
  transition: all 0.2s;
}
.rep_minimize:hover {
  transform: scale(1.02);
}
.rep_minimize.light {
  background-color: white;
  color: #1a75e9;
}
.rep_minimize.light > p {
  font-size: 20px;
}
.rep_minimize > .rep_title {
  font-size: 20px;
}
</style>
